import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import { ShareMovementButton } from "@/components/home/ShareMovementButton";
import { HOME } from "@/constants/testIds";

const HERO_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_web-app-hub-36/artifacts/9bttb9tx_New%20Wallpaper%20for%20BBAP%20Wesbite";
const PRINTIFY_URL = "https://bias-buster-store.printify.me/";

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden border-b border-bbap-border">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="" className="w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_75%_70%_at_50%_40%,rgba(245,249,252,0.82)_0%,rgba(245,249,252,0.58)_55%,rgba(245,249,252,0.1)_100%)]" />
      </div>
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 sm:pt-28 pb-14 text-center">
        <div className="flex justify-center mb-8">
          <Logo showText={false} size="h-44" />
        </div>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#1E3A6E] mb-4">Bias Behavior Analysis Platform</p>
        <h1 data-testid={HOME.heroHeadline} className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-zinc-950 leading-[1.15]">
          Bias is behavior. Behavior can be changed.
        </h1>
        <p className="mt-4 text-lg md:text-xl font-display font-bold text-[#1E3A6E]">
          An integrated problem requires an integrated solution.
        </p>
        <p className="mt-6 text-base md:text-lg text-zinc-600 max-w-2xl mx-auto leading-relaxed">
          Racial bias can leave people isolated and traumatized, with effects that last long after the
          incident. The integrated solution starts with people coming
          together — to listen, document what happened, connect people with support, and turn patterns into
          organized change.
        </p>
        <p className="mt-4 text-base md:text-lg text-zinc-600 max-w-2xl mx-auto leading-relaxed">
          That's the idea behind BiasBuster — the Bias Behavior Analysis Platform (BAP). Every experience
          matters, and no one should have to face it alone.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/donate" data-testid={HOME.heroDonateButton}>
            <Button size="lg" className="bg-[#1E3A6E] text-white font-semibold rounded-none px-10 py-6 text-base hover:bg-zinc-950 hover:shadow-[0px_4px_0px_0px_#4FD1C5] transition-all w-full sm:w-auto">
              Donate Now
            </Button>
          </Link>
          <ShareMovementButton
            testId={HOME.heroShareButton}
            className="border-zinc-300 text-zinc-950 rounded-none hover:border-zinc-950 w-full sm:w-auto"
          />
          <a href={PRINTIFY_URL} target="_blank" rel="noopener noreferrer" data-testid={HOME.heroMerchButton} className="w-full sm:w-auto">
            <Button size="lg" variant="outline" className="border-zinc-300 text-zinc-600 rounded-none hover:border-zinc-950 hover:text-zinc-950 w-full sm:w-auto">
              Shop Merch <ExternalLink className="h-4 w-4 ml-2" />
            </Button>
          </a>
        </div>
        <Link to="/feed" data-testid="home-view-feed-button" className="mt-6 inline-block text-sm font-semibold text-zinc-500 hover:text-zinc-950 underline">
          Or see the Voting Feed &rarr;
        </Link>
      </div>
    </section>
  );
}
